import { watch, onBeforeUnmount } from "#imports";
import { useLoadingStore } from "~/store/loading/loadingStore";

/**
 * 로딩(loadingStore.show)이 thresholdMs 이상 지속되면 onTimeout을 1회 호출한다.
 *
 * 평가 진행 중 네트워크 단발 유실(Zscaler/국제 구간 등)로 요청 응답이 돌아오지
 * 않을 때 무한 로딩이 발생한다. 이때 응시자에게 새로고침 안내를 노출해 자가복구를
 * 유도하기 위한 컴포저블. (TSK-10923)
 */
export function useLoadingTimeoutGuide(onTimeout: () => void, thresholdMs = 20000) {
  const loadingStore = useLoadingStore();
  let timerId: ReturnType<typeof setTimeout> | null = null;
  let fired = false;

  const clear = () => {
    if (timerId !== null) {
      clearTimeout(timerId);
      timerId = null;
    }
  };

  const start = () => {
    clear();
    fired = false;
    timerId = setTimeout(() => {
      // 임계 시간 경과 시점에도 여전히 로딩 중이면 안내 노출 (사이클당 1회)
      if (loadingStore.show && !fired) {
        fired = true;
        onTimeout();
      }
    }, thresholdMs);
  };

  watch(
    () => loadingStore.show,
    (show) => {
      if (show) start();
      else clear();
    },
    { immediate: true }
  );

  onBeforeUnmount(clear);

  return { clear };
}
